<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>Thank you to all of the team at Austin Macauley Publishers Ltd. for bringing <em>Unwelcome Legacies</em> to life and helping me fulfil my dream of becoming a published author.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?07a5533e